import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface TodoRiesgoConstruccionIntroScreenProps {
	onNext: () => void
}

export function TodoRiesgoConstruccionIntroScreen({
	onNext,
}: TodoRiesgoConstruccionIntroScreenProps) {
	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-6">
					<div className="flex size-16 items-center justify-center rounded-full bg-orange-100">
						<Icon name="pencil-1" className="size-8 text-orange-700" />
					</div>

					<h1 className="font-parkinsans text-center text-3xl leading-10 font-medium text-blue-800">
						Seguro Todo Riesgo Construcción
					</h1>

					<p className="text-center text-base leading-6 text-neutral-600">
						Protección integral para obras de construcción contra daños
						materiales, responsabilidad civil y riesgos asociados.
					</p>

					<div className="flex w-full flex-col gap-3 rounded-2xl bg-neutral-100 p-4">
						<p className="font-inter text-sm font-semibold text-blue-800">
							¿Qué necesitás tener a mano?
						</p>
						<ul className="font-inter flex flex-col gap-2 text-sm text-neutral-700">
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Título y ubicación del proyecto</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Datos del propietario y contratistas</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Descripción técnica de la obra</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Plazos y períodos del seguro</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Información sobre riesgos del sitio</span>
							</li>
						</ul>
					</div>

					<div className="flex w-full flex-col gap-2 rounded-xl bg-blue-50 p-3">
						<p className="font-inter text-sm font-medium text-blue-800">
							Este seguro cubre:
						</p>
						<ul className="font-inter grid grid-cols-2 gap-1 text-xs text-blue-700">
							<li>• Daños materiales a la obra</li>
							<li>• Incendio y explosión</li>
							<li>• Fenómenos naturales</li>
							<li>• Responsabilidad civil</li>
							<li>• Equipos y maquinarias</li>
							<li>• Período de mantenimiento</li>
						</ul>
					</div>

					<div className="flex w-full items-center gap-3 rounded-xl bg-orange-50 p-3">
						<Icon name="clock" className="size-5 shrink-0 text-orange-600" />
						<p className="font-inter text-sm text-orange-800">
							El proceso toma aproximadamente <strong>10-15 minutos</strong>
						</p>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-center gap-2 bg-white pt-4 md:bg-transparent md:pt-8">
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onNext}
					className="w-full md:w-auto"
				>
					Comenzar
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
